export default __webpack_public_path__ + "static/media/android.ef2e90e1.gif";